<div class="certificate-container" dir="rtl">
  <div class="form-wrapper">
    <!-- Main Title -->
    <div class="main-title">
      <h2>بيانات الشهادة البنكية</h2>
    </div>

    <div class="form-section">
      <div
        class="alert info"
        *ngIf="checked && !['LLC', 'OPC'].includes(legalSituation?.code)"
      >
        <span class="icon">ℹ️</span>
        <span>
          يرجى إرفاق شهادة تكويد الأسهم الصادرة من مصر للمقاصة مع الشهادة
          البنكية
        </span>
      </div>
      <div class="upload-section">
        <div class="upload-header">
          <input
            type="checkbox"
            id="bankCertificate"
            (input)="isFormCecked()"
            [(ngModel)]="checked"
            [disabled]="isReadOnly || isCheckboxDisabled"
          />
          <label for="bankCertificate" class="upload-label">
            تم استخراج شهادة بنكية؟
          </label>
        </div>

        <a
          *ngIf="!checked"
          [routerLink]="['/bank-certificate-info']"
          class="info-link"
          tabindex="0"
          aria-label="معلومات إضافية"
          target="_blank"
        >
          إضغط هنا إذا لم تستخرج شهادة بنكية
        </a>
      </div>
    </div>

    <div class="form-section-data" *ngIf="checked">
      <form [formGroup]="form">
        <fieldset [disabled]="isReadOnly" class="readonly-fieldset">

          <!-- iScore OFF: original layout, file upload first -->
          <div class="form-row" *ngIf="!isIscoreEnabled">
            <app-file-upload
              label="شهادة بنكية"
              [required]="true"
              tooltipText="يجب رفع كافة صفحات المستند كاملة في ملف واحد PDF"
              acceptedTypes=".pdf"
              errorMessage="يرجى تحميل شهادة شهادة بنكية (PDF فقط)"
              formControlName="idDocument"
              [filePath]="filePath"
              (uploadComplete)="onUploadComplete($event)"
              (fileRemoved)="onFileRemoved()"
            >
            </app-file-upload>
          </div>

          <div class="forms">

            <div class="form-row-inline d-flex" *ngIf="isIscoreEnabled">
              <div class="inline-field">
                <label for="certificateNumber" class="required"
                  >رقم الشهادة البنكية</label
                >
                <input
                  maxlength="50"
                  type="text"
                  id="certificateNumber"
                  formControlName="certificateNumber"
                />
                <div
                  class="error-message"
                  *ngIf="
                    form.get('certificateNumber')?.invalid &&
                    form.get('certificateNumber')?.touched &&
                    !isReadOnly
                  "
                >
                  يرجى إدخال رقم الشهادة البنكية
                </div>
              </div>

              <div class="inline-field">
                <label for="bankName" class="required">اسم البنك</label>
                <select id="bankName" formControlName="bankName">
                  <option value="">-- من فضلك اختر --</option>
                  <option *ngFor="let bank of banks" [value]="bank.id">
                    {{ bank.nameAr }}
                  </option>
                </select>
                <div
                  class="error-message"
                  *ngIf="
                    form.get('bankName')?.invalid &&
                    form.get('bankName')?.touched &&
                    !isReadOnly
                  "
                >
                  يرجى إدخال اسم البنك
                </div>
              </div>

              <div class="inline-field">
                <app-file-upload label="شهادة بنكية" [required]="true" tooltipText="يجب رفع كافة صفحات المستند كاملة في ملف واحد PDF"
                  acceptedTypes=".pdf" errorMessage="يرجى تحميل شهادة شهادة بنكية (PDF فقط)" formControlName="idDocument"
                  [filePath]="filePath">
                </app-file-upload>
              </div>
              <div class="inline-field inline-field-button">
                <button
                  type="button"
                  class="save-btn"
                  [disabled]="isReadOnly || !isIscoreTriggerReady || isIscoreLoading"
                  (click)="onLoadIscoreData()"
                >
                  {{ isIscoreLoading ? 'جاري التحميل...' : 'تحميل البيانات' }}
                </button>
              </div>
            </div>
            <!-- <div class="form-row form-row-inline" *ngIf="isIscoreEnabled && iscoreError">
              <div class="error-message">{{ iscoreError }}</div>
            </div> -->

            <!-- iScore ON: rest of the fields, files included — blocked until a successful load -->


            <!-- iScore OFF: original standalone certificateNumber -->
            <div class="form-row" *ngIf="!isIscoreEnabled">
              <label for="certificateNumber" class="required"
                >رقم الشهادة البنكية</label
              >
              <input
                maxlength="50"
                type="text"
                id="certificateNumber"
                formControlName="certificateNumber"
              />
              <div
                class="error-message"
                *ngIf="
                  form.get('certificateNumber')?.invalid &&
                  form.get('certificateNumber')?.touched &&
                  !isReadOnly
                "
              >
                يرجى إدخال رقم الشهادة البنكية
              </div>
            </div>

            <div class="form-row">
              <label for="certificateDate" class="required"
                >تاريخ الشهادة البنكية</label
              >
              <app-custom-date-input  [validationType]="'custom'" [maxDate]="maxDate" formControlName="certificateDate"></app-custom-date-input>
              <div
                class="error-message"
                *ngIf="
                  form.get('certificateDate')?.invalid &&
                  form.get('certificateDate')?.touched &&
                  !isReadOnly
                "
              >
                يرجى اختيار تاريخ الشهادة البنكية
              </div>
            </div>

            <!-- iScore OFF: original standalone bankName -->
            <div class="form-row" *ngIf="!isIscoreEnabled">
              <label for="bankName" class="required">اسم البنك</label>
              <select id="bankName" formControlName="bankName">
                <option value="">-- من فضلك اختر --</option>
                <option *ngFor="let bank of banks" [value]="bank.id">
                  {{ bank.nameAr }}
                </option>
              </select>
              <div
                class="error-message"
                *ngIf="
                  form.get('bankName')?.invalid &&
                  form.get('bankName')?.touched &&
                  !isReadOnly
                "
              >
                يرجى إدخال اسم البنك
              </div>
            </div>

            <div class="form-row">
              <label for="bankBranch" class="required">اسم فرع البنك</label>
              <input
                type="text"
                id="bankBranch"
                formControlName="bankBranch"
                maxlength="100"
              />
              <div
                class="error-message"
                *ngIf="
                  form.get('bankBranch')?.invalid &&
                  form.get('bankBranch')?.touched &&
                  !isReadOnly
                "
              >
                يرجى إدخال فرع البنك
              </div>
            </div>

            <!-- <div class="form-row" *ngIf="this.legalSituation?.code !== 'JSC'">
              <label for="companyAccountNumber"
                >رقم حساب الشركة تحت التأسيس</label
              >
              <input
                type="text"
                id="companyAccountNumber"
                formControlName="companyAccountNumber"
                maxlength="50"
              />
            </div> -->

            <div class="form-row" style="margin-bottom: 50px">
              <label for="paidCapital" class="required"
                >النسبة المدفوعة من رأس المال(%)</label
              >
              <input
                type="number"
                id="paidCapital"
                formControlName="paidCapital"
                [(ngModel)]="paidCapital"
              />
            </div>

            <div
              class="form-row"
              *ngIf="this.legalSituation?.code === 'JSC'"
            ></div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</div>